import { render, staticRenderFns } from "./PaintingExhibition.vue?vue&type=template&id=e43e7baa&"
import script from "./PaintingExhibition.vue?vue&type=script&lang=js&"
export * from "./PaintingExhibition.vue?vue&type=script&lang=js&"
import style0 from "./PaintingExhibition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports